import type { ReactNode } from 'react';

interface Props {
    title: ReactNode;
}

export const CheckoutStepHeader = ({ title }: Props) => (
    <header className='margin-bottom-20 text-center'>
        <h3 className='margin-0'>{title}</h3>
    </header>
);
